import React, { useEffect, useState } from "react";
import axios from "axios";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";

import {
  Button,
  DinamicInputWithSearchBar,
  Input,
  InputOdontograma,
  InputSufix,
  Select,
  SelectMarket,
  Textarea,
} from "../../components/Form";
import { getAge } from "../../utils/age";
import { BiChevronDown, BiPlus, BiSave } from "react-icons/bi";
import {
  LaboratoryTable,
  MedicineDosageTable,
  OdontogramaTable,
} from "../../components/Tables";
import { toast } from "react-hot-toast";
import MedicineDosageModal from "../../components/Modals/MedicineDosage";
import { FaFileDownload, FaSave } from "react-icons/fa";
import { HiOutlineCheckCircle, HiOutlinePencilAlt } from "react-icons/hi";
import ThreeColumRow from "../../components/ThreeColumRow";
import TwoColumRow from "../../components/TwoColumRow";
import LaboratoryServiceModal from "../../components/Modals/LaboratoryServiceModal";
import { useDispatch, useSelector } from "react-redux";
import {
  getByOdontogramaPatient,
  getOdontograma,
  getVisita,
  getVisitasByCitaId,
  updateVisita,
} from "../../redux/features/visitasSlice";
import {
  getPlacesAtention,
  getPainMout,
  getDeviationMout,
  getNoiseArticulateMout,
  getDislocationMout,
  getFaceProfile,
  getPositionLips,
  getBreathing,
  getAmygdala,
  getBacterialPlaque,
  getTartaro,
  getSaliva,
  getRightMolar,
  getLeftMolar,
  getRightCannine,
  getLeftCannine,
  getToothPiece,
  getDiagnosis,
  getTreatment,
  getParameters,
} from "../../redux/features/parametersSlice";

import { useForm } from "react-hook-form";
import ConfirmationAlert from "../../components/ConfirmationAlert";
import { Enfermedades } from "../../components/EnfermedadesCIE";
import {
  createReceta,
  updateReceta,
  deleteRecetaByVisitaId,
  getAllRecetas,
  getRecetasById,
} from "../../redux/features/recetaSlice";
import { pdf } from "@react-pdf/renderer";
import RecetaPdf from "../../pdf/RecetaPdf";
import OdontogramaPdf from "../../pdf/OdontogramaPdf";
import { saveAs } from "file-saver";
import {
  deleteEstudio,
  getAllEstudiosByCita,
  getEstudiosByCitaId,
} from "../../redux/features/estudiosSlice";
import OrdenPdf from "../../pdf/OrdenPdf";
import { RiDeleteBinLine } from "react-icons/ri";
import HistoriaPdf from "../../pdf/HistoriaPdf";
import { getAllCitas } from "../../redux/features/citasSlice";

import {
  createOdontograma,
  getOdontogramaByCitaId,
  getAllOdontogramaByCita,
} from "../../redux/features/odontogramaSlice";
import SelectedChartOdontogramaModal from "../../components/Modals/SelectedChartOdontograma";
import HistorialTratamientos from "./HistorialTratamientos";
import NotasCita from "./NotasCita";
import { apiUrl, specificConfigurationDataUrl } from "../../redux/apiUrl";

const formatFechaCiclo = (isoStr) => {
  if (!isoStr) return '';
  try {
    return new Intl.DateTimeFormat('es', {
      day: '2-digit', month: '2-digit', year: 'numeric',
      timeZone: 'America/La_Paz',
    }).format(new Date(isoStr));
  } catch {
    return isoStr.slice(0, 10);
  }
};

function NewMedicalRecode({ cita, defaultTab }) {
  const [isOpen, setIsOpen] = useState(false);
  const [labOpen, setLabOpen] = useState(false);
  const [isOpenModalChart, setIsOpenModalChart] = useState(false);
  const [ciclo, setCiclo] = useState(null);
  // const [motivo, setMotivo] = useState("");
  const lugaresAtencion = useSelector(getPlacesAtention);
  const [lugarAtencion, setLugarAtencion] = useState({ name: "Ninguno" });

  const [dolorBucal, setDolorBucal] = useState({ name: "Ninguno" });
  const OpcionesdolorBucal = useSelector(getPainMout);

  const [DesvioBucal, setDesvioBucal] = useState({ name: "Ninguno" });
  const OpcionesDesvioBucal = useSelector(getDeviationMout);

  const [RuidoArticularBucal, setRuidoArticularBucal] = useState({
    name: "Ninguno",
  });
  const OpcionesRuidoArticularBucal = useSelector(getNoiseArticulateMout);

  const [LuxacionBucal, setLuxacionBucal] = useState({ name: "Ninguno" });
  const OpcionesLuxacionBucal = useSelector(getDislocationMout);

  const [PerfilFacial, setPerfilFacial] = useState({ name: "Ninguno" });
  const OpcionesPerfilFacial = useSelector(getFaceProfile);

  const [PosturaLabial, setPosturaLabial] = useState({ name: "Ninguno" });
  const OpcionesPosturaLabial = useSelector(getPositionLips);

  const [TipoRespiracion, setTipoRespiracion] = useState({ name: "Ninguno" });
  const OpcionesTipoRespiracion = useSelector(getBreathing);

  const [AgmidalasPal, setAgmídalasPal] = useState({ name: "Ninguno" });
  const OpcionesAgmídalasPal = useSelector(getAmygdala);

  const [PlacaBacteriana, setPlacaBacteriana] = useState({ name: "No" });
  const OpcionesPlacaBacteriana = useSelector(getBacterialPlaque);

  const [Tartaro, setTartaro] = useState({ name: "No" });
  const OpcionesTartaro = useSelector(getTartaro);

  const [Saliva, setSaliva] = useState({ name: "Ninguno" });
  const OpcionesSaliva = useSelector(getSaliva);

  const [RelacionMolarDer, setRelacionMolarDer] = useState({ name: "Ninguno" });
  const OpcionesRelacionMolarDer = useSelector(getRightMolar);

  const [RelacionMolarIzq, setRelacionMolarIzq] = useState({ name: "Ninguno" });
  const OpcionesRelacionMolarIzq = useSelector(getLeftMolar);

  const [RelacionCaninaDer, setRelacionCaninaDer] = useState({
    name: "Ninguno",
  });
  const OpcionesRelacionCaninaDer = useSelector(getRightCannine);

  const [RelacionCaninaIzq, setRelacionCaninaIzq] = useState({
    name: "Ninguno",
  });
  const OpcionesRelacionCaninaIzq = useSelector(getLeftCannine);

  const OpcionesPiezaDental = useSelector(getToothPiece);

  const OpcionesDiagnosis = useSelector(getDiagnosis);

  const OpcionesTratamiento = useSelector(getTreatment);

  const [valueIMC, setValueIMC] = useState("Ingrese el peso y la altura.");
  const [diagnostico, setDiagnostico] = useState("");
  const [receta, setReceta] = useState([]);
  const [editingReceta, setEditingReceta] = useState(false);
  const dispatch = useDispatch();
  const visita = useSelector(getVisita);
  // Visita/odontograma más reciente del paciente entre TODAS sus citas (no solo la de hoy) — se usa
  // para no mostrar "debe crear un odontograma" cuando el paciente ya tiene atenciones previas y
  // simplemente todavía no se guardó la visita de la cita actual. Ver el ternario del Odontograma.
  const odontogramaPacientePrevio = useSelector(getOdontograma);
  const recetasFromBack = useSelector(getAllRecetas);
  const estudios = useSelector(getAllEstudiosByCita);
  const [activeTab, setActiveTab] = useState(
    defaultTab ?? 0
  );
  const [allEstudios, setAllEstudios] = useState();

  const allCitas = useSelector(getAllCitas);
  const odontogramas = useSelector(getAllOdontogramaByCita);
  const [piezaDental, setPiezaDental] = useState("");
  const [diagnosticoDental, setDiagnosticoDental] = useState("");
  const [tratamiento, setTratamiento] = useState("");
  const [totalOdontograma, setTotalOdontograma] = useState(0);
  const [costoOdontograma, setCostoOdontograma] = useState("");
  const [filteredData, setFilteredDataTratamiento] = useState([]);
  const [filteredDataDiagnostico, setFilteredDataDiagnostico] = useState([]);
  const [filteredDataPiezaDental, setFilteredDataPiezaDental] = useState([]);
  const [diagnosticoOdontograma, setDiagnosticoOdontograma] = useState([]);
  const [odontogramasData, setOdontogramasData] = useState([]);
  const [chartsForSelected, setChartsForSelected] = useState([]);
  const [descuento, setDescuento] = useState(0);
  const [doctorData, setDoctorData] = useState(null);

  const handleChange = (e) => {
    setTratamiento(e.target.value);
    let filteredTratamiento = OpcionesTratamiento.filter((item) =>
      item.name.toLowerCase().includes(tratamiento.trim().toLowerCase())
    );
    if (filteredTratamiento.length > 10)
      filteredTratamiento = filteredTratamiento.slice(0, 10);

    if (tratamiento.length === 0)
      setFilteredDataTratamiento(OpcionesTratamiento.slice(0, 10));
    else setFilteredDataTratamiento(filteredTratamiento);
  };

  const handleChangeDiagnostico = (ev) => {
    setDiagnosticoDental(ev.target.value);
    let filteredDiagnostico = OpcionesDiagnosis.filter((item) =>
      item.name.toLowerCase().includes(diagnosticoDental.trim().toLowerCase())
    );
    if (filteredDiagnostico.length > 10)
      filteredDiagnostico = filteredDiagnostico.slice(0, 10);

    if (diagnosticoDental.length === 0)
      setFilteredDataDiagnostico(OpcionesDiagnosis.slice(0, 10));
    else setFilteredDataDiagnostico(filteredDiagnostico);
  };

  const handleChangePiezaDental = (e) => {
    setPiezaDental(e.target.value);
    let filteredPiezaDental = OpcionesPiezaDental.filter((item) =>
      item.name.toLowerCase().includes(piezaDental.trim().toLowerCase())
    );

    if (filteredPiezaDental.length > 10)
      filteredPiezaDental = filteredPiezaDental.slice(0, 10);

    if (piezaDental.length === 0)
      setFilteredDataPiezaDental(OpcionesPiezaDental.slice(0, 10));
    else setFilteredDataPiezaDental(filteredPiezaDental);
  };

  useEffect(() => {
    let filteredPiezaDental = OpcionesPiezaDental.filter((item) =>
      item.name.toLowerCase().includes(piezaDental.trim().toLowerCase())
    );
    piezaDental?.length > 0 && setFilteredDataPiezaDental(filteredPiezaDental);
  }, [piezaDental]);

  useEffect(() => {
    let filteredDiagnostico = OpcionesDiagnosis.filter((item) =>
      item.name.toLowerCase().includes(diagnosticoDental.trim().toLowerCase())
    );

    diagnosticoDental?.length > 0 &&
      setFilteredDataDiagnostico(filteredDiagnostico);
  }, [diagnosticoDental]);

  useEffect(() => {
    let filteredTratamiento = OpcionesTratamiento.filter((item) =>
      item.name.toLowerCase().includes(tratamiento.trim().toLowerCase())
    );

    tratamiento?.length > 0 && setFilteredDataTratamiento(filteredTratamiento);
  }, [tratamiento]);

  const handleChangeCosto = (e) => {
    setCostoOdontograma(e.target.value);
  };

  const handleChangeTotal = (value) => {
    setTotalOdontograma(value);
  };

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    watch,
    reset,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    dispatch(getParameters());
  }, []);

  useEffect(() => {
    if (cita?.id) {
      dispatch(getVisitasByCitaId(cita?.id));
      dispatch(getOdontogramaByCitaId(cita?.id));
      dispatch(getEstudiosByCitaId(cita?.id));
    }
    if (cita?.patient_id) {
      dispatch(getByOdontogramaPatient(cita.patient_id));
    }
  }, [cita?.id, cita?.patient_id, dispatch]);

  useEffect(() => {
    if (cita?.tipo_evento !== 'Re Consulta' || !cita?.patient_id || !cita?.parent_cita_id) {
      setCiclo(null);
      return;
    }
    const patientCitas = allCitas.filter(c => c.patient_id === cita.patient_id);
    const source = patientCitas.length > 0 ? patientCitas : null;

    const computeCiclo = (data) => {
      const parent = data.find(c => c.id === cita.parent_cita_id) ?? null;
      const prevRCs = data
        .filter(c =>
          c.tipo_evento === 'Re Consulta' &&
          c.parent_cita_id === cita.parent_cita_id &&
          c.id < cita.id
        )
        .sort((a, b) => new Date(b.fecha) - new Date(a.fecha));
      setCiclo({ parent, prevRCs });
    };

    if (source) {
      computeCiclo(source);
    } else {
      // Fallback: Redux no tiene citas de este paciente (navegación directa)
      axios.get(`${apiUrl}/api/v1/citas/${cita.patient_id}`)
        .then(({ data }) => computeCiclo(data))
        .catch(() => {});
    }
  }, [cita?.id, cita?.tipo_evento, cita?.patient_id, cita?.parent_cita_id, allCitas]);

  useEffect(() => {
    if (visita?.id) {
      dispatch(getRecetasById(visita.id));
      if (visita?.motivo) {
        setValue("motivo", visita.motivo);
      }

      setDiagnostico(visita.diagnostico);
      if (visita.lugar_atencion) {
        setLugarAtencion(
          lugaresAtencion.find(
            (lugar) => lugar.name === visita.lugar_atencion
          ) ?? { name: "Ninguno" }
        );
      }

      setDiagnostico(visita.diagnostico);
      if (visita.PlacaBacteriana) {
        setPlacaBacteriana(
          OpcionesPlacaBacteriana.find(
            (PlacaBacteriana) => PlacaBacteriana.name === visita.PlacaBacteriana
          ) ?? { name: "Ninguno" }
        );
      }
      setDiagnostico(visita.diagnostico);
      if (visita.dolorBucal) {
        setDolorBucal(
          OpcionesdolorBucal.find(
            (dolorBucal) => dolorBucal.name === visita.dolorBucal
          ) ?? { name: "Ninguno" }
        );
      }
      if (visita.DesvioBucal) {
        setDesvioBucal(
          OpcionesDesvioBucal.find(
            (DesvioBucal) => DesvioBucal.name === visita.DesvioBucal
          ) ?? { name: "Ninguno" }
        );
      }
      if (visita.RuidoArticularBucal) {
        setRuidoArticularBucal(
          OpcionesRuidoArticularBucal.find(
            (RuidoArticularBucal) =>
              RuidoArticularBucal.name === visita.RuidoArticularBucal
          ) ?? { name: "Ninguno" }
        );
      }
      if (visita.LuxacionBucal) {
        setLuxacionBucal(
          OpcionesLuxacionBucal.find(
            (LuxacionBucal) => LuxacionBucal.name === visita.LuxacionBucal
          ) ?? { name: "Ninguno" }
        );
      }
      if (visita.PerfilFacial) {
        setPerfilFacial(
          OpcionesPerfilFacial.find(
            (PerfilFacial) => PerfilFacial.name === visita.PerfilFacial
          ) ?? { name: "Ninguno" }
        );
      }
      if (visita.PosturaLabial) {
        setPosturaLabial(
          OpcionesPosturaLabial.find(
            (PosturaLabial) => PosturaLabial.name === visita.PosturaLabial
          ) ?? { name: "Ninguno" }
        );
      }
      if (visita.TipoRespiracion) {
        setTipoRespiracion(
          OpcionesTipoRespiracion.find(
            (TipoRespiracion) => TipoRespiracion.name === visita.TipoRespiracion
          ) ?? { name: "Ninguno" }
        );
      }
      if (visita.AgmidalasPal) {
        setAgmídalasPal(
          OpcionesAgmídalasPal.find(
            (AgmidalasPal) => AgmidalasPal.name === visita.AgmidalasPal
          ) ?? { name: "Ninguno" }
        );
      }
      setDiagnostico(visita.diagnostico);
      if (visita.Tartaro) {
        setTartaro(
          OpcionesTartaro.find(
            (Tartaro) => Tartaro.name === visita.Tartaro
          ) ?? { name: "Ninguno" }
        );
      }
      setDiagnostico(visita.diagnostico);
      if (visita.Tartaro) {
        setTartaro(
          OpcionesTartaro.find((Tartaro) => Tartaro.name === visita.Tartaro) ??
            OpcionesTartaro[0]
        );
      }
      setDiagnostico(visita.diagnostico);
      if (visita.Saliva) {
        setSaliva({ name: visita.Saliva });
      }
      setDiagnostico(visita.diagnostico);
      if (visita.RelacionMolarIzq) {
        setRelacionMolarIzq(
          OpcionesRelacionMolarIzq.find(
            (RelacionMolarIzq) =>
              RelacionMolarIzq.name === visita.RelacionMolarIzq
          ) ?? { name: "Ninguno" }
        );
      }
      setDiagnostico(visita.diagnostico);
      if (visita.RelacionMolarDer) {
        setRelacionMolarDer(
          OpcionesRelacionMolarDer.find(
            (RelacionMolarDer) =>
              RelacionMolarDer.name === visita.RelacionMolarDer
          ) ?? { name: "Ninguno" }
        );
      }
      setDiagnostico(visita.diagnostico);
      if (visita.RelacionCaninaIzq)
        setRelacionCaninaIzq(
          OpcionesRelacionCaninaIzq.find(
            (RelacionCaninaIzq) =>
              RelacionCaninaIzq.name === visita.RelacionCaninaIzq
          ) ?? { name: "Ninguno" }
        );

      setDiagnostico(visita.diagnostico);
      if (visita.RelacionCaninaDer)
        setRelacionCaninaDer(
          OpcionesRelacionCaninaDer.find(
            (RelacionCaninaDer) =>
              RelacionCaninaDer.name === visita.RelacionCaninaDer
          ) ?? { name: "Ninguno" }
        );
      setValue("lugar_atencion", lugarAtencion.name);
      setValue("altura", visita?.altura);
      setValue("comentarios", visita?.comentarios);
      setValue("conducta", visita?.conducta);
      setValue("desglose_motivo", visita?.desglose_motivo);
      setValue("examen_fisico", visita?.examen_fisico);
      setValue("f_cardiaca", visita?.f_cardiaca);
      setValue("f_respiratoria", visita?.f_respiratoria);
      setValue("p_arterial_1", visita?.p_arterial_1);
      setValue("p_arterial_5", visita?.p_arterial_5);
      setValue("peso", visita?.peso);
      setValue("temperatura", visita?.temperatura);

      setValue("t_encias", visita.t_encias);
      setValue("t_mucosas", visita.t_mucosas);
      setValue("t_labios", visita.t_labios);
      setValue("t_lengua", visita.t_lengua);
      setValue("l_apertura", visita.l_apertura);
      setValue("t_paladar", visita.t_paladar);
      setValue("t_pisobucal", visita.t_pisobucal);
      setValue("t_halitosis", visita.t_halitosis);
    }
  }, [visita?.id, recetasFromBack.length, OpcionesdolorBucal.length]);

  useEffect(() => {
    if (odontogramas) {
      setOdontogramasData((prev) => {
        if (JSON.stringify(prev) !== JSON.stringify(odontogramas)) {
          return odontogramas;
        }
        return prev;
      });
    }
  }, [odontogramas]);

  const onSubmit = async (body) => {
    ConfirmationAlert({
      title: "Guardar Visita",
      text: `Estas seguro de guardar los datos de la visita?`,
      onAccept: async () => {
        body.id = visita?.id;
        body.diagnostico = diagnostico;
        body.lugar_atencion = lugarAtencion?.name;

        body.dolorBucal = dolorBucal?.name;
        body.DesvioBucal = DesvioBucal?.name;
        body.RuidoArticularBucal = RuidoArticularBucal?.name;
        body.LuxacionBucal = LuxacionBucal?.name;
        body.PerfilFacial = PerfilFacial?.name;
        body.PosturaLabial = PosturaLabial?.name;
        body.TipoRespiracion = TipoRespiracion?.name;
        body.AgmidalasPal = AgmidalasPal?.name;
        body.PlacaBacteriana = PlacaBacteriana?.name;
        body.Tartaro = Tartaro?.name;
        body.Saliva = Saliva?.name;
        body.RelacionMolarIzq = RelacionMolarIzq?.name;
        body.RelacionMolarDer = RelacionMolarDer?.name;
        body.RelacionCaninaIzq = RelacionCaninaIzq?.name;
        body.RelacionCaninaDer = RelacionCaninaDer?.name;

        const newData = await dispatch(updateVisita(body));
        if (newData?.error) {
          toast.error(
            `No se pudo guardar los datos de la visita: ${newData.error}`,
            { duration: 5000 }
          );
        } else {
          toast.success("Datos de visita guardados con exito!", {
            duration: 5000,
          });
          window.location.reload();
          //navigate(0);
        }
      },
    });
  };

  const calculateIMC = (peso, altura) => {
    if (peso > 0 && altura > 0) {
      const IMC = Number.parseFloat(
        peso / (((altura / 100) * altura) / 100)
      ).toFixed(2);

      if (IMC < 18.5) return `${IMC} - Bajo Peso`;
      if (IMC < 25) return `${IMC} - Peso Saludable`;
      if (IMC < 30) return `${IMC} - Sobrepeso`;
      return `${IMC} - Obesidad`;
    }
    return "Ingrese el peso y la altura.";
  };

  useEffect(() => {
    const pesoF = getValues("peso");
    const alturaF = getValues("altura");
    setValueIMC(calculateIMC(pesoF, alturaF));
  }, [getValues("peso"), getValues("altura")]);

  useEffect(() => {
    // useeffect para obtener los datos del doctor by Yamil

    const fetchDoctorData = async () => {
      try {
        const response = await fetch(specificConfigurationDataUrl);
        if (!response.ok) {
          throw new Error("Error al obtener los datos del doctor");
        }
        const data = await response.json();
        setDoctorData(data);
      } catch (error) {
        console.error("Error:", error);
      }
    };

    fetchDoctorData();
  }, []);

  const handleIMC = () => {
    const pesoF = getValues("peso");
    const alturaF = getValues("altura");
    setValueIMC(calculateIMC(pesoF, alturaF));
  };

  const handlePdfReceta = async () => {
    if (receta.length === 0 && recetasFromBack?.length === 0) {
      toast.error("Agregue elementos a la receta!", { duration: 5000 });
      return;
    }
    // Una receta se guarda ligada a la Visita de la cita (no a la cita directamente) — si todavía
    // no se guardó nada en la pestaña "Atención" para esta cita, no hay Visita y el backend
    // rechaza el guardado. Se avisa acá con un mensaje claro en vez de dejar que falle con un
    // error críptico.
    if (!visita?.id) {
      toast.error(
        "Primero tenés que guardar la pestaña \"Atención\" de esta cita — la receta se guarda ligada a esa visita.",
        { duration: 6000 }
      );
      return;
    }
    if (recetasFromBack?.length === 0) {
      ConfirmationAlert({
        title: "Generar Receta",
        text: `Estas seguro de generar la receta? Ya no podra editar despues de generar la receta.`,
        onAccept: async () => {
          const datosReceta = {
            visita_id: visita?.id,
            recetas: receta,
          };
          const newData = await dispatch(createReceta(datosReceta));
          if (newData?.error) {
            toast.error(`No se pudo generar la receta: ${newData.error?.message || newData.error}`, {
              duration: 5000,
            });
            return;
          } else {
            dispatch(getRecetasById(visita?.id));
            toast.success("Receta guardada con exito!", {
              duration: 5000,
            });
          }
        },
      });
    } else {
      const blob = await pdf(
        <RecetaPdf
          data={{
            nombre: `${cita?.patient?.persona?.nombre} ${cita?.patient?.persona?.apellidos}`,
            edad: `${
              cita?.patient?.persona?.fecha_nacimiento
                ? getAge(new Date(cita?.patient?.persona?.fecha_nacimiento)) +
                  " años"
                : ""
            }`,
            fecha: new Date().toLocaleDateString("en-GB"),
            lugarAtencion:
              visita?.lugar_atencion ?? `${getValues("lugar_atencion")}`,
            seguro: `${cita?.patient?.empresa_seg ?? ""}`,
            recetas: recetasFromBack,
            doctor: doctorData,
          }}
        />
      ).toBlob();
      saveAs(
        blob,
        `Receta-${visita.id}-${new Date().toLocaleDateString("en-GB")}.pdf`
      );
    }
  };

  // Entrar en modo edición: copia la receta ya guardada al estado local editable (sin el `id`
  // de backend, para que la tabla la trate como ítems locales — mismo mecanismo que usa "Guardar"
  // para una receta nueva). Al confirmar, update() reemplaza TODA la receta de la visita.
  const handleEditReceta = () => {
    setReceta(
      (recetasFromBack ?? []).map(
        ({ id, visita_id, created_at, updated_at, ...rest }) => rest
      )
    );
    setEditingReceta(true);
  };

  const handleCancelEditReceta = () => {
    setReceta([]);
    setEditingReceta(false);
  };

  const handleSaveRecetaEdit = () => {
    if (receta.length === 0) {
      toast.error("Agregue elementos a la receta!", { duration: 5000 });
      return;
    }
    ConfirmationAlert({
      title: "Guardar cambios",
      text: `Esta seguro de guardar los cambios en la receta?`,
      onAccept: async () => {
        const newData = await dispatch(
          updateReceta({ visita_id: visita?.id, recetas: receta })
        );
        if (newData?.error) {
          toast.error(`No se pudo actualizar la receta: ${newData.error}`, {
            duration: 5000,
          });
          return;
        } else {
          setEditingReceta(false);
          setReceta([]);
          dispatch(getRecetasById(visita?.id));
          toast.success("Receta actualizada con exito!", { duration: 5000 });
        }
      },
    });
  };

  const deleteReceta = () => {
    ConfirmationAlert({
      title: "Eliminar Receta",
      text: `Estas seguro de eliminar la receta? Ya no podra recuperar la informacion despues de eliminar la receta.`,
      onAccept: async () => {
        const newData = await dispatch(deleteRecetaByVisitaId(visita?.id));
        if (newData?.error) {
          toast.error(`No se pudo elimar la receta: ${newData.error}`, {
            duration: 5000,
          });
          return;
        } else {
          setReceta([]);
          dispatch(getRecetasById(visita?.id));
          toast.success("Receta eliminada con exito!", {
            duration: 5000,
          });
        }
      },
    });
  };

  const handleImpresionIC = async () => {
    const blob = await pdf(
      <HistoriaPdf
        data={{
          patient: cita?.patient,
          visita,
          receta: recetasFromBack,
          doctor: doctorData,
        }}
      />
    ).toBlob();
    saveAs(
      blob,
      `HC-${visita.id}-${new Date().toLocaleDateString("en-GB")}.pdf`
    );
  };

  const handleAgregarOdontograma = () => {
    if (!piezaForm || !diagnosticoForm) {
      toast.error(
        "Necesita al menos indicar la pieza dental y el diagnóstico!",
        {
          duration: 5000,
        }
      );
      return;
    }

    if (piezaForm?.length > 2 && !piezaForm?.toLowerCase().includes("tx")) {
      toast.error(
        `Solo puede agregar un diente esta intentando agregar: ${piezaForm}!`,
        {
          duration: 5000,
        }
      );
      return;
    }

    const alreadyExists = (existDiente) => {
      return (
        diagnosticoOdontograma.some((item) => item.diente === existDiente) ||
        odontogramasData.some((item) => item.diente === existDiente)
      );
    };

    const respaldoDientes = [
      { number1: "15", number2: "55" },
      { number1: "14", number2: "54" },
      { number1: "13", number2: "53" },
      { number1: "12", number2: "52" },
      { number1: "11", number2: "51" },
      { number1: "21", number2: "61" },
      { number1: "22", number2: "62" },
      { number1: "23", number2: "63" },
      { number1: "24", number2: "64" },
      { number1: "25", number2: "65" },
      { number1: "35", number2: "75" },
      { number1: "34", number2: "74" },
      { number1: "33", number2: "73" },
      { number1: "32", number2: "72" },
      { number1: "31", number2: "71" },
      { number1: "41", number2: "81" },
      { number1: "42", number2: "82" },
      { number1: "43", number2: "83" },
      { number1: "44", number2: "84" },
      { number1: "45", number2: "85" },
    ];

    const alreadyExistsTuple = () => {
      const found_diente = respaldoDientes.find(
        (diente) =>
          diente.number1 === piezaDental || diente.number2 === piezaDental
      );
      if (!found_diente) {
        return null;
      }
      const send_diente =
        piezaDental === found_diente.number1
          ? found_diente.number2
          : found_diente.number1;
      return alreadyExists(send_diente) ? found_diente : null;
    };

    const updateOdontograma = async () => {
      const newEntry = {
        diente: piezaForm,
        diagnostico: diagnosticoForm,
        tratamiento: tratamientoForm,
        costo: costoForm,
      };

      const newOdontogramasData = [...odontogramasData, newEntry];

      setDiagnosticoOdontograma((prev) => [...prev, newEntry]);
      setOdontogramasData(newOdontogramasData);
      reset({ pieza: "", tratamiento: "", diagnostico: "", costo: "" });

      const datosOdontograma = newOdontogramasData.map((item) => ({
        cita_id: cita?.id,
        diente: item.diente,
        diagnostico: item.diagnostico,
        tratamiento: item.tratamiento,
        costo: item.costo,
      }));
      const res = await dispatch(createOdontograma({
        cita_id: cita?.id,
        odontogramas: JSON.stringify(datosOdontograma),
      }));
      if (res?.error) {
        toast.error(`No se pudo guardar el odontograma: ${res.error}`);
      } else {
        toast.success("Odontograma guardado!");
      }
    };

    if (alreadyExists(piezaForm) || alreadyExistsTuple()) {
      ConfirmationAlert({
        title: `Pieza dental: ${piezaForm} ya existe`,
        text: `Desea agregar un nuevo registro de la pieza: ${piezaForm}`,
        onAccept: updateOdontograma,
      });
      return;
    } else {
      updateOdontograma();
    }
  };

  const piezaForm = watch("pieza");
  const diagnosticoForm = watch("diagnostico");
  const tratamientoForm = watch("tratamiento");
  const costoForm = watch("costo");
  const tratamientoEscogido = watch("tratamiento");

  useEffect(() => {
    const tratamiento = OpcionesTratamiento.find(
      (t) => t.name === tratamientoEscogido
    );
    if (tratamiento) {
      setValue("costo", tratamiento.descripcion || "");
    }
  }, [tratamientoEscogido, setValue]);

  const deleteRecordByIndex = (diente) => {
    setOdontogramasData((prevData) =>
      prevData.filter(
        (piezaDental) =>
          !(
            diente.diente === piezaDental.piezaDental &&
            diente.diagnostico === piezaDental.diagnostico &&
            diente.tratamiento === piezaDental.tratamiento &&
            diente.costo === piezaDental.costo
          )
      )
    );
    setDiagnosticoOdontograma((prevData) =>
      prevData.filter(
        (piezaDental) =>
          !(
            diente.diente === piezaDental.piezaDental &&
            diente.diagnostico === piezaDental.diagnostico &&
            diente.tratamiento === piezaDental.tratamiento &&
            diente.costo === piezaDental.costo
          )
      )
    );
  };

  const updateRecord = (prevData, updatedData, actualData) => {
    setDiagnosticoOdontograma(() => {
      const dataLocal = actualData.map((data) =>
        data.diente === prevData.diente &&
        data.diagnostico === prevData.diagnostico &&
        data.tratamiento === prevData.tratamiento
          ? {
              ...data,
              diagnostico: updatedData.diagnostico,
              tratamiento: updatedData.tratamiento,
              costo: updatedData.costo,
            }
          : data
      );
      return dataLocal;
    });

    setOdontogramasData(() => {
      const dataLocal = actualData.map((data) =>
        data.diente === prevData.diente &&
        data.diagnostico === prevData.diagnostico &&
        data.tratamiento === prevData.tratamiento
          ? {
              ...data,
              diagnostico: updatedData.diagnostico,
              tratamiento: updatedData.tratamiento,
              costo: updatedData.costo,
            }
          : data
      );
      return dataLocal;
    });
  };

  const handleCreateOdontograma = async () => {
    ConfirmationAlert({
      title: "Crear Odontograma",
      text: `Estas seguro de crear el odontograma?`,
      onAccept: async () => {
        const datosOdontograma = odontogramasData.map((item) => ({
          cita_id: cita?.id,
          diente: item.diente,
          diagnostico: item.diagnostico,
          tratamiento: item.tratamiento,
          costo: item.costo,
        }));
        const dataOdontogramaSend = {
          cita_id: cita?.id,
          odontogramas: JSON.stringify(datosOdontograma),
        };
        dispatch(createOdontograma(dataOdontogramaSend));
        dispatch(updateVisita({ ...visita, descuento: descuento }));
        if (datosOdontograma?.error) {
          toast.error(
            `No se pudo crear el odontograma: ${datosOdontograma.error}`,
            {
              duration: 5000,
            }
          );
          return;
        } else {
          toast.success("Odontograma creado con exito!", {
            duration: 5000,
          });
        }
      },
    });
  };

  useEffect(() => {
    const nuevoOdontogramas = odontogramasData.map((d) => {
      const odonto = diagnosticoOdontograma.find(
        (od) => d.piezaDental === od.diente
      );
      if (odonto) {
        return {
          piezaDental: odonto.diente,
          diagnostico: odonto.diagnostico,
          tratamiento: odonto.tratamiento,
          costo: odonto.costo,
          selected: false,
        };
      }
      return { ...d, selected: false };
    });
    setChartsForSelected(nuevoOdontogramas);
  }, [diagnosticoOdontograma, odontogramasData]);

  const handlePdfOdontograma = async () => {
    if (chartsForSelected?.length > 0) {
      // La tabla `visitas` no tiene columna `descuento` — ese valor SOLO vive en el estado local
      // `descuento` (por eso el Total en pantalla sí lo restaba bien). El PDF antes leía
      // `visita?.descuento`, que siempre es undefined, y por eso nunca mostraba el descuento ni
      // restaba nada del total, sin importar qué pieza se seleccionara.
      const blob = await pdf(
        <OdontogramaPdf
          nombre={`${cita?.patient?.persona?.nombre} ${cita?.patient?.persona?.apellidos}`}
          edad={`${
            cita?.patient?.persona?.fecha_nacimiento
              ? getAge(cita?.patient?.persona?.fecha_nacimiento) + " años"
              : ""
          }`}
          fecha={new Date().toLocaleDateString("en-GB")}
          lugarAtencion={
            visita?.lugar_atencion ?? `${getValues("lugar_atencion")}`
          }
          seguro={`${cita?.patient?.empresa_seg ?? "Ninguno"}`}
          odontogramasBackEnd={chartsForSelected}
          descuento={descuento}
          doctorData={doctorData}
        />
      ).toBlob();
      saveAs(
        blob,
        `Proforma-${visita?.id}-${new Date().toLocaleDateString("en-GB")}.pdf`
      );
    } else {
      toast.error("El arreglo no tiene ningun dato!", {
        duration: 5000,
      });
    }
  };

  return (
    <>
      {
        // modal
        isOpen && (
          <MedicineDosageModal
            isOpen={isOpen}
            setReceta={setReceta}
            closeModal={() => {
              setIsOpen(false);
            }}
          />
        )
      }
      {
        // modal
        labOpen && (
          <LaboratoryServiceModal
            isOpen={labOpen}
            closeModal={() => {
              setLabOpen(!labOpen);
            }}
            visita={visita}
          />
        )
      }
      {isOpenModalChart && (
        <div className="w-full overflow-x-scroll">
          <SelectedChartOdontogramaModal
            isOpen={isOpenModalChart}
            datas={chartsForSelected}
            title={"Impresion de Proforma"}
            text={"¿Quiere imprimir las piezas seleccionadas?"}
            functions={{
              printOdontograma: handlePdfOdontograma,
              setDatas: setChartsForSelected,
            }}
            closeModal={() => {
              setIsOpenModalChart(!isOpenModalChart);
            }}
          />
        </div>
      )}
      {cita?.tipo_evento === "Re Consulta" ? (
        /* ── Vista simplificada para Re Consulta ── */
        <Tabs className="border-border" defaultFocus={true}>
          <TabList>
            <Tab>Sesión</Tab>
            <Tab>Piezas</Tab>
            <Tab>Historial</Tab>
          </TabList>

          {/* Tab Sesión: historial del ciclo + notas de la re consulta */}
          <TabPanel>
            <div className="bg-white rounded-xl p-6 flex flex-col gap-4">

              {/* Historial del ciclo */}
              {ciclo && (ciclo.parent || ciclo.prevRCs.length > 0) && (
                <div className="flex flex-col gap-2 border-b border-border pb-4">
                  <p className="text-xs font-semibold text-textGray uppercase tracking-wide">Flujo de atención</p>
                  <div className="flex flex-col">
                    {ciclo.prevRCs.map((rc, idx) => (
                      <div key={rc.id} className="flex items-stretch gap-3">
                        <div className="flex flex-col items-center flex-shrink-0 w-4">
                          <div className="w-2.5 h-2.5 rounded-full bg-subMain mt-1 flex-shrink-0" />
                          <div className="w-px flex-1 bg-border" />
                        </div>
                        <div className="pb-3 flex-1">
                          <p className="text-xs font-medium text-main">
                            {formatFechaCiclo(rc.fecha)}{' '}
                            <span className="text-textGray font-normal">— Re Consulta</span>
                          </p>
                          {rc.visita?.comentarios && (
                            <p className="text-xs text-textGray mt-0.5 leading-relaxed">{rc.visita.comentarios}</p>
                          )}
                        </div>
                      </div>
                    ))}
                    {ciclo.parent && (
                      <div className="flex items-start gap-3">
                        <div className="flex flex-col items-center flex-shrink-0 w-4">
                          <div className="w-2.5 h-2.5 rounded-full bg-main mt-1 flex-shrink-0" />
                        </div>
                        <div className="pb-1">
                          <p className="text-xs font-medium text-main">
                            {formatFechaCiclo(ciclo.parent.fecha)}{' '}
                            <span className="text-textGray font-normal">— {ciclo.parent.tipo_evento}</span>
                          </p>
                          <p className="text-xs text-textGray">Consulta de origen</p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}

              <p className="text-sm font-medium text-main">Notas de la sesión</p>
              <textarea
                rows={5}
                placeholder="Describa lo realizado en esta sesión..."
                defaultValue={visita?.comentarios ?? ""}
                onChange={(e) => setValue("comentarios", e.target.value)}
                className="w-full text-sm border border-border rounded-lg p-3 focus:outline-none focus:border-subMain resize-none text-main placeholder-textGray"
              />
              <div className="flex justify-end">
                <button
                  onClick={handleSubmit(async (body) => {
                    body.id = visita?.id;
                    const res = await dispatch(updateVisita({ id: visita?.id, comentarios: body.comentarios }));
                    if (res?.error) {
                      toast.error("Error al guardar las notas");
                    } else {
                      toast.success("Notas guardadas");
                    }
                  })}
                  className="flex items-center gap-2 bg-subMain text-white text-sm rounded-lg px-4 py-2 hover:opacity-90 transition-opacity"
                >
                  <FaSave />
                  Guardar notas
                </button>
              </div>
            </div>
          </TabPanel>

          {/* Tab Piezas: notas por pieza del odontograma original */}
          <TabPanel>
            <div className="bg-white rounded-xl p-6">
              <NotasCita cita={cita} />
            </div>
          </TabPanel>

          {/* Tab Historial */}
          <TabPanel>
            <HistorialTratamientos patientId={cita?.patient_id} patient={cita?.patient} />
          </TabPanel>
        </Tabs>
      ) : (
      <Tabs
        className="border-border"
        selectedIndex={activeTab}
        onSelect={(index) => setActiveTab(index)}
        forceRenderTabPanel={true}
        defaultFocus={true}
      >
        <TabList>
          {cita?.tipo_evento !== "Analisis o Laboratorio" && (
            <>
              <Tab>Atención</Tab>
              <Tab>Recetas</Tab>
            </>
          )}
          <Tab>Imagenologia y Laboratorios</Tab>
          <Tab>Odontograma</Tab>
          <Tab>Historial</Tab>
        </TabList>
        {cita?.tipo_evento !== "Analisis o Laboratorio" && (
          <>
            <TabPanel>
              {/* Atencion */}
              <div className=" grid grid-cols-12 gap-6 items-start">
                <div
                  data-aos="fade-left"
                  data-aos-duration="1000"
                  data-aos-delay="100"
                  data-aos-offset="200"
                  className="col-span-12 lg:col-span-12 bg-white rounded-xl p-6"
                >
                  <div className="flex w-full flex-col gap-5">
                    <Button label="Imprimir HC" onClick={handleImpresionIC} />
                    <div className="flex w-full flex-col gap-2">
                      <p className="text-black text-sm">Lugar de Atención</p>
                      <Select
                        selectedPerson={lugarAtencion}
                        setSelectedPerson={setLugarAtencion}
                        datas={lugaresAtencion}
                      >
                        <div className="w-full flex-btn text-textGray text-sm p-4 border border-border font-light rounded-lg focus:border focus:border-subMain">
                          {lugarAtencion?.name}
                          <BiChevronDown className="text-xl" />
                        </div>
                      </Select>
                    </div>
                    <Textarea
                      label="Motivo de la consulta"
                      color={true}
                      rows={3}
                      visible={true}
                      placeholder={"Dolor..."}
                      name="motivo"
                      register={register("motivo")}
                      setValue={setValue}
                      getValue={getValues}
                    />
                    {/* <Textarea
											label="Enfermedad Actual"
											color={true}
											rows={3}
											register={register("desglose_motivo")}
											name="desglose_motivo"
											setValue={setValue}
											getValue={getValues}
											placeholder={"Dolor abdominal y ...."}
										/> */}

                    {/* Vital Signs */}
                    <div className="border p-5 rounded-lg flex flex-col gap-3">
                      <h2 className="mb-3">Examen Físico General</h2>
                      <TwoColumRow>
                        <Input
                          label="Frecuencia Cardiaca (latidos por minuto)"
                          color={true}
                          type="number"
                          register={register("f_cardiaca")}
                          placeholder="0-200"
                        />
                        <Input
                          label="Presion Arterial 1'"
                          color={true}
                          type="text"
                          register={register("p_arterial_1")}
                          placeholder="40- 230/0-160"
                        />
                        {/* <Input
													label="Presion Arterial 5'"
													color={true}
													type="text"
													register={register("p_arterial_5")}
													placeholder="40- 230/0-160"
												/> */}
                      </TwoColumRow>
                      <TwoColumRow>
                        <InputSufix
                          label="Frecuencia Respiratoria (respiracion por minuto)"
                          color={true}
                          type="text"
                          register={register("f_respiratoria")}
                          placeholder="0-340 rpm"
                          suffix={" rpm"}
                        />
                        <Input
                          label="Temperatura °C"
                          color={true}
                          type="number"
                          register={register("temperatura")}
                          placeholder="36"
                        />
                      </TwoColumRow>
                      <ThreeColumRow>
                        <Input
                          label="Peso"
                          color={true}
                          type="number"
                          register={register("peso", { onChange: handleIMC })}
                          placeholder="36 kg"
                        />
                        <Input
                          label="Altura"
                          color={true}
                          type="number"
                          register={register("altura", { onChange: handleIMC })}
                          placeholder="175cm"
                        />
                        <div className="flex flex-col justify-center items-center ">
                          <p>IMC</p>
                          <p className="p-4 font-medium">{valueIMC}</p>
                        </div>
                        p
                      </ThreeColumRow>
                      <Textarea
                        label="Examen Regional"
                        color={true}
                        rows={3}
                        register={register("examen_fisico")}
                        name="examen_fisico"
                        setValue={setValue}
                        getValue={getValues}
                        placeholder={"Otros datos del examen físico, ...."}
                      />
                    </div>

                    {/* Probando */}
                    <div className="border p-5 rounded-lg flex flex-col gap-3">
                      <h2 className="mb-3">Extra Bucal</h2>
                      <TwoColumRow>
                        <div className="flex w-full flex-col gap-2">
                          <p className="text-black text-sm">Dolor de la ATM</p>
                          <Select
                            selectedPerson={dolorBucal}
                            setSelectedPerson={setDolorBucal}
                            datas={OpcionesdolorBucal}
                          >
                            <div className="w-full flex-btn text-textGray text-sm p-4 border border-border font-light rounded-lg focus:border focus:border-subMain">
                              {dolorBucal?.name}{" "}
                              <BiChevronDown className="text-xl" />
                            </div>
                          </Select>
                        </div>

                        <div className="flex w-full flex-col gap-2">
                          <p className="text-black text-sm">Desvío</p>
                          <Select
                            selectedPerson={DesvioBucal}
                            setSelectedPerson={setDesvioBucal}
                            datas={OpcionesDesvioBucal}
                          >
                            <div className="w-full flex-btn text-textGray text-sm p-4 border border-border font-light rounded-lg focus:border focus:border-subMain">
                              {DesvioBucal?.name}{" "}
                              <BiChevronDown className="text-xl" />
                            </div>
                          </Select>
                        </div>
                      </TwoColumRow>

                      <TwoColumRow>
                        <Input
                          label="Apertura Interincisal Maxima (mm)"
                          color={true}
                          type="number"
                          step="0.01"
                          register={register("l_apertura")}
                          placeholder="0.00"
                        />

                        <div className="flex w-full flex-col gap-2">
                          <p className="text-black text-sm">Ruido Articular</p>
                          <Select
                            selectedPerson={RuidoArticularBucal}
                            setSelectedPerson={setRuidoArticularBucal}
                            datas={OpcionesRuidoArticularBucal}
                          >
                            <div className="w-full flex-btn text-textGray text-sm p-4 border border-border font-light rounded-lg focus:border focus:border-subMain">
                              {RuidoArticularBucal?.name}{" "}
                              <BiChevronDown className="text-xl" />
                            </div>
                          </Select>
                        </div>
                      </TwoColumRow>

                      <TwoColumRow>
                        <div className="flex w-full flex-col gap-2">
                          <p className="text-black text-sm">Luxación</p>
                          <Select
                            selectedPerson={LuxacionBucal}
                            setSelectedPerson={setLuxacionBucal}
                            datas={OpcionesLuxacionBucal}
                          >
                            <div className="w-full flex-btn text-textGray text-sm p-4 border border-border font-light rounded-lg focus:border focus:border-subMain">
                              {LuxacionBucal?.name}{" "}
                              <BiChevronDown className="text-xl" />
                            </div>
                          </Select>
                        </div>

                        <div className="flex w-full flex-col gap-2">
                          <p className="text-black text-sm">Perfil Facial</p>
                          <Select
                            selectedPerson={PerfilFacial}
                            setSelectedPerson={setPerfilFacial}
                            datas={OpcionesPerfilFacial}
                          >
                            <div className="w-full flex-btn text-textGray text-sm p-4 border border-border font-light rounded-lg focus:border focus:border-subMain">
                              {PerfilFacial?.name}{" "}
                              <BiChevronDown className="text-xl" />
                            </div>
                          </Select>
                        </div>
                      </TwoColumRow>

                      <TwoColumRow>
                        <div className="flex w-full flex-col gap-2">
                          <p className="text-black text-sm">Postura Labial</p>
                          <Select
                            selectedPerson={PosturaLabial}
                            setSelectedPerson={setPosturaLabial}
                            datas={OpcionesPosturaLabial}
                          >
                            <div className="w-full flex-btn text-textGray text-sm p-4 border border-border font-light rounded-lg focus:border focus:border-subMain">
                              {PosturaLabial?.name}{" "}
                              <BiChevronDown className="text-xl" />
                            </div>
                          </Select>
                        </div>

                        <div className="flex w-full flex-col gap-2">
                          <p className="text-black text-sm">Respiración</p>
                          <Select
                            selectedPerson={TipoRespiracion}
                            setSelectedPerson={setTipoRespiracion}
                            datas={OpcionesTipoRespiracion}
                          >
                            <div className="w-full flex-btn text-textGray text-sm p-4 border border-border font-light rounded-lg focus:border focus:border-subMain">
                              {TipoRespiracion?.name}{" "}
                              <BiChevronDown className="text-xl" />
                            </div>
                          </Select>
                        </div>
                      </TwoColumRow>
                    </div>

                    <div className="border p-5 rounded-lg flex flex-col gap-3">
                      <h2 className="mb-3">Examen de Boca</h2>
                      <Textarea
                        label="Labios"
                        color={true}
                        rows={3}
                        register={register("t_labios")}
                        name="t_labios"
                        setValue={setValue}
                        getValue={getValues}
                        placeholder={" "}
                      />

                      <Textarea
                        label="Lengua"
                        color={true}
                        rows={3}
                        register={register("t_lengua")}
                        name="t_lengua"
                        setValue={setValue}
                        getValue={getValues}
                        placeholder={" "}
                      />
                      {/* <TwoColumRow>
					  	<Textarea
							label="Labios"
							color={true}
							rows={3}
							register={register("t_labios")}
							name="t_labios"
							setValue={setValue}
							getValue={getValues}
							placeholder={" "}
						/>

						<Textarea
							label="Lengua"
							color={true}
							rows={3}
							register={register("t_lengua")}
							name="t_lengua"
							setValue={setValue}
							getValue={getValues}
							placeholder={" "}
						/>
                      </TwoColumRow> */}

                      <Textarea
                        label="Encias"
                        color={true}
                        rows={3}
                        register={register("t_encias")}
                        name="t_encias"
                        setValue={setValue}
                        getValue={getValues}
                        placeholder={" "}
                      />

                      <Textarea
                        label="Mucosas"
                        color={true}
                        rows={3}
                        register={register("t_mucosas")}
                        name="t_mucosas"
                        setValue={setValue}
                        getValue={getValues}
                        placeholder={" "}
                      />

                      <TwoColumRow>
                        <Input
                          label="Paladar"
                          color={true}
                          type="text"
                          register={register("t_paladar")}
                        />
                        <Input
                          label="Piso Bucal"
                          color={true}
                          type="text"
                          register={register("t_pisobucal")}
                        />
                      </TwoColumRow>

                      <TwoColumRow>
                        <div className="flex w-full flex-col gap-2">
                          <p className="text-black text-sm">
                            Amígdalas Palatinas
                          </p>
                          <Select
                            selectedPerson={AgmidalasPal}
                            setSelectedPerson={setAgmídalasPal}
                            datas={OpcionesAgmídalasPal}
                          >
                            <div className="w-full flex-btn text-textGray text-sm p-4 border border-border font-light rounded-lg focus:border focus:border-subMain">
                              {AgmidalasPal?.name}{" "}
                              <BiChevronDown className="text-xl" />
                            </div>
                          </Select>
                        </div>

                        <Input
                          label="Halitosis"
                          color={true}
                          type="text"
                          register={register("t_halitosis")}
                        />
                      </TwoColumRow>

                      <ThreeColumRow>
                        <div className="flex w-full flex-col gap-2">
                          <p className="text-black text-sm">Placa Bacteriana</p>
                          <Select
                            selectedPerson={PlacaBacteriana}
                            setSelectedPerson={setPlacaBacteriana}
                            datas={OpcionesPlacaBacteriana}
                          >
                            <div className="w-full flex-btn text-textGray text-sm p-4 border border-border font-light rounded-lg focus:border focus:border-subMain">
                              {PlacaBacteriana?.name}{" "}
                              <BiChevronDown className="text-xl" />
                            </div>
                          </Select>
                        </div>

                        <div className="flex w-full flex-col gap-2">
                          <p className="text-black text-sm">Tártaro</p>
                          <Select
                            selectedPerson={Tartaro}
                            setSelectedPerson={setTartaro}
                            datas={OpcionesTartaro}
                          >
                            <div className="w-full flex-btn text-textGray text-sm p-4 border border-border font-light rounded-lg focus:border focus:border-subMain">
                              {Tartaro?.name}{" "}
                              <BiChevronDown className="text-xl" />
                            </div>
                          </Select>
                        </div>

                        <div className="flex w-full flex-col gap-2">
                          <p className="text-black text-sm">Saliva</p>

                          <SelectMarket
                            selectedPerson={Saliva}
                            setSelectedPerson={setSaliva}
                            datas={OpcionesSaliva}
                            prefValue={"Ninguno"}
                          >
                            <div className="w-full flex-btn text-textGray text-sm p-4 border border-border font-light rounded-lg focus:border focus:border-subMain">
                              {Saliva?.name}{" "}
                              <BiChevronDown className="text-xl" />
                            </div>
                          </SelectMarket>
                        </div>
                      </ThreeColumRow>

                      <TwoColumRow>
                        <div className="flex w-full flex-col gap-2">
                          <p className="text-black text-sm">Relacion Molar I</p>
                          <Select
                            selectedPerson={RelacionMolarIzq}
                            setSelectedPerson={setRelacionMolarIzq}
                            datas={OpcionesRelacionMolarIzq}
                          >
                            <div className="w-full flex-btn text-textGray text-sm p-4 border border-border font-light rounded-lg focus:border focus:border-subMain">
                              {RelacionMolarIzq?.name}{" "}
                              <BiChevronDown className="text-xl" />
                            </div>
                          </Select>
                        </div>

                        <div className="flex w-full flex-col gap-2">
                          <p className="text-black text-sm">Relacion Molar D</p>
                          <Select
                            selectedPerson={RelacionMolarDer}
                            setSelectedPerson={setRelacionMolarDer}
                            datas={OpcionesRelacionMolarDer}
                          >
                            <div className="w-full flex-btn text-textGray text-sm p-4 border border-border font-light rounded-lg focus:border focus:border-subMain">
                              {RelacionMolarDer?.name}{" "}
                              <BiChevronDown className="text-xl" />
                            </div>
                          </Select>
                        </div>
                      </TwoColumRow>

                      <TwoColumRow>
                        <div className="flex w-full flex-col gap-2">
                          <p className="text-black text-sm">
                            Relacion Canina I
                          </p>
                          <Select
                            selectedPerson={RelacionCaninaIzq}
                            setSelectedPerson={setRelacionCaninaIzq}
                            datas={OpcionesRelacionCaninaIzq}
                          >
                            <div className="w-full flex-btn text-textGray text-sm p-4 border border-border font-light rounded-lg focus:border focus:border-subMain">
                              {RelacionCaninaIzq?.name}{" "}
                              <BiChevronDown className="text-xl" />
                            </div>
                          </Select>
                        </div>

                        <div className="flex w-full flex-col gap-2">
                          <p className="text-black text-sm">
                            Relacion Canina D
                          </p>
                          <Select
                            selectedPerson={RelacionCaninaDer}
                            setSelectedPerson={setRelacionCaninaDer}
                            datas={OpcionesRelacionCaninaDer}
                          >
                            <div className="w-full flex-btn text-textGray text-sm p-4 border border-border font-light rounded-lg focus:border focus:border-subMain">
                              {RelacionCaninaDer?.name}{" "}
                              <BiChevronDown className="text-xl" />
                            </div>
                          </Select>
                        </div>
                      </TwoColumRow>
                    </div>

                    {/* Probando Fin */}

                    <DinamicInputWithSearchBar
                      label="Diagnostico"
                      color={true}
                      rows={3}
                      visible={true}
                      datos={diagnostico}
                      dataSearch={Enfermedades}
                      setDatos={setDiagnostico}
                      placeholder={"CIE-10..."}
                    />
                    <Textarea
                      label="Notas"
                      color={true}
                      rows={3}
                      register={register("comentarios")}
                      name="comentarios"
                      setValue={setValue}
                      getValue={getValues}
                      placeholder={"Notas...."}
                    />
                    <Textarea
                      label="Conducta"
                      color={true}
                      rows={3}
                      register={register("conducta")}
                      name="conducta"
                      setValue={setValue}
                      getValue={getValues}
                      placeholder={"Conducta ...."}
                    />
                    <Button
                      label={"Guardar"}
                      Icon={HiOutlineCheckCircle}
                      onClick={handleSubmit(onSubmit)}
                    />
                  </div>
                </div>
              </div>
            </TabPanel>

            <TabPanel>
              {/* receta */}
              <div className=" grid grid-cols-12 gap-6 items-start">
                <div
                  data-aos="fade-left"
                  data-aos-duration="1000"
                  data-aos-delay="100"
                  data-aos-offset="200"
                  className="col-span-12 lg:col-span-12 bg-white rounded-xl p-6"
                >
                  <div>
                    <div className="flex w-full flex-col gap-4 mb-6">
                      <div className="flex justify-between items-center">
                        <p className="text-black text-lg">Prescripción</p>
                        <div className="flex gap-2">
                          {editingReceta ? (
                            <>
                              <button
                                onClick={handleSaveRecetaEdit}
                                className="flex justify-center items-center bg-subMain rounded-lg text-white text-center text-2xl p-2"
                              >
                                <span className="text-sm mr-1">
                                  Guardar cambios
                                </span>{" "}
                                <FaSave />
                              </button>
                              <button
                                onClick={handleCancelEditReceta}
                                className="bg-gray-100 text-gray-600 rounded-lg border border-gray-200 py-3 px-4 text-sm"
                              >
                                Cancelar
                              </button>
                            </>
                          ) : (
                            <>
                              <button
                                onClick={() => handlePdfReceta()}
                                className="flex justify-center items-center bg-subMain rounded-lg text-white text-center text-2xl p-2"
                              >
                                <span className="text-sm mr-1">
                                  {recetasFromBack?.length > 0
                                    ? "Imprimir "
                                    : "Guardar "}
                                </span>{" "}
                                {recetasFromBack?.length > 0 ? (
                                  <FaFileDownload />
                                ) : (
                                  <BiSave />
                                )}
                              </button>
                              {recetasFromBack?.length > 0 && (
                                <button
                                  onClick={handleEditReceta}
                                  className="bg-subMain bg-opacity-5 text-subMain rounded-lg border border-subMain border-opacity-20 py-3 px-4 text-sm"
                                >
                                  <HiOutlinePencilAlt />
                                </button>
                              )}
                              {recetasFromBack?.length > 0 && (
                                <button
                                  onClick={deleteReceta}
                                  className="bg-red-600 bg-opacity-5 text-red-600 rounded-lg border border-red-100 py-3 px-4 text-sm"
                                >
                                  <RiDeleteBinLine />
                                </button>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                      <div className="w-full overflow-x-scroll">
                        <MedicineDosageTable
                          data={
                            editingReceta
                              ? receta
                              : recetasFromBack.length > 0
                              ? recetasFromBack
                              : receta
                          }
                          functions={{
                            delete: (id) => {
                              setReceta((state) =>
                                state.filter((_, index) => index !== id)
                              );
                              toast.success("Elemento eliminado!");
                            },
                          }}
                          button={true}
                        />
                      </div>
                      {(recetasFromBack?.length === 0 || editingReceta) && (
                        <button
                          onClick={() => {
                            setIsOpen(true);
                          }}
                          className=" text-subMain flex-rows gap-2 rounded-lg border border-subMain border-dashed py-4 w-full text-sm"
                        >
                          <BiPlus /> Agregar Medicamento
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </TabPanel>
          </>
        )}
        <TabPanel>
          {/* Imagenologia y Laboratorios */}
          <div className=" grid grid-cols-12 gap-6 items-start">
            <div
              data-aos="fade-left"
              data-aos-duration="1000"
              data-aos-delay="100"
              data-aos-offset="200"
              className="col-span-12 lg:col-span-12 bg-white rounded-xl p-6"
            >
              <div>
                <div className="flex w-full flex-col gap-3">
                  <div className="flex justify-between items-center">
                    <p className="text-black text-lg">
                      Imagenologia y Laboratorios
                    </p>
                    {/* <button className="flex justify-center items-center bg-subMain rounded-xl text-white text-center text-2xl p-2"> <FaFileDownload /> </button> */}
                  </div>

                  <div className="w-full overflow-x-scroll">
                    <LaboratoryTable
                      data={estudios}
                      functions={{
                        delete: (body) => {
                          ConfirmationAlert({
                            title: "Eliminar Orden",
                            text: "Esta seguro de eliminar la orden?",
                            onAccept: async () => {
                              const res = await dispatch(deleteEstudio(body));
                              if (res?.error) {
                                toast.error(
                                  "No se pudo eliminar la orden, " + res.error
                                );
                              } else {
                                dispatch(
                                  getEstudiosByCitaId(cita?.id)
                                );
                                toast.success("Orden eliminada correctamente!");
                              }
                            },
                          });
                        },
                        printPdf: async (body) => {
                          const blob = await pdf(
                            <OrdenPdf
                              data={{
                                nombre: `${cita?.patient?.persona?.nombre} ${cita?.patient?.persona?.apellidos}`,
                                edad: `${
                                  cita?.patient?.persona?.fecha_nacimiento
                                    ? getAge(
                                        new Date(
                                          cita?.patient?.persona?.fecha_nacimiento
                                        )
                                      ) + " años"
                                    : ""
                                }`,
                                fecha: new Date().toLocaleDateString("en-GB"),
                                lugarAtencion:
                                  visita?.lugar_atencion ??
                                  `${getValues("lugar_atencion")}`,
                                seguro: `${cita?.patient?.empresa_seg ?? ""}`,
                                orden: body,
                                doctor: doctorData,
                              }}
                            />
                          ).toBlob();
                          saveAs(
                            blob,
                            `Orden-${visita.id}-${new Date().toLocaleDateString(
                              "en-GB"
                            )}.pdf`
                          );
                        },
                      }}
                      button={true}
                      patient={cita?.patient}
                    />
                  </div>
                  <button
                    onClick={() => {
                      setLabOpen(true);
                    }}
                    className=" text-subMain flex-rows gap-2 rounded-lg border border-subMain border-dashed py-4 w-full text-sm"
                  >
                    <BiPlus /> Agregar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </TabPanel>
        <TabPanel forceRender={true}>
          {/* Odontograma */}
          {cita?.tipo_evento === "Re Consulta" ? (
            <div className="bg-white rounded-xl p-6">
              <div className="m-2 mb-4">
                <p className="text-black text-lg">Notas de Re Consulta</p>
              </div>
              <NotasCita cita={cita} />
            </div>
          ) : (
          <div className=" grid grid-cols-12 gap-6 items-start">
            <div
              data-aos="fade-left"
              data-aos-duration="1000"
              data-aos-delay="100"
              data-aos-offset="200"
              className="col-span-12 lg:col-span-12 bg-white rounded-xl p-6"
            >
              <div className="m-2">
                <p className="text-black text-lg ">Odontograma:</p>
              </div>
              {visita || odontogramaPacientePrevio ? (
                <div className="flex flex-col justify-around">
                  <div className="flex items-center justify-center">
                    <img
                      className="h-auto max-w-full rounded-lg "
                      alt="Odontograma"
                      src="/images/odontograma.png"
                    />
                  </div>
                  <div className="col-span-5 lg:col-span-5 p-6">
                    <div className="grid grid-cols-1 md:grid-cols-5 gap-3 items-start">
                      {/* Pieza Dental */}
                      <div>
                        <InputOdontograma
                          id="pieza"
                          label="Pieza dental"
                          color={true}
                          register={register("pieza", {
                            onChange: (e) => handleChangePiezaDental(e),
                            onBlur: () => setFilteredDataPiezaDental([]),
                            onMouseDown: (e) => handleChangePiezaDental(e),
                          })}
                          type={"text"}
                          error={""}
                        />
                        {filteredDataPiezaDental?.length > 0 && (
                          <ul className="max-h-40 w-full border absolute rounded-lg z-50 bg-white overflow-y-scroll">
                            {filteredDataPiezaDental?.map((item) => (
                              <li
                                key={item.id}
                                onMouseDown={() => {
                                  setValue("pieza", item.name);
                                  setTimeout(
                                    setFilteredDataPiezaDental([]),
                                    10
                                  );
                                }}
                                className="border-b py-2 px-5"
                              >
                                {`${item.name}`}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>

                      {/* Diagnostico */}
                      <div>
                        <InputOdontograma
                          label="Diagnostico"
                          color={true}
                          register={register("diagnostico", {
                            onChange: (ev) => handleChangeDiagnostico(ev),
                            onBlur: () => setFilteredDataDiagnostico([]),
                            onMouseDown: (ev) => handleChangeDiagnostico(ev),
                          })}
                          type={"text"}
                        />
                        {filteredDataDiagnostico?.length > 0 && (
                          <ul className="max-h-40 w-full border absolute rounded-lg z-50 bg-white overflow-y-scroll">
                            {filteredDataDiagnostico?.map((item) => (
                              <li
                                key={item.id}
                                onMouseDown={() => {
                                  setValue("diagnostico", item.name);
                                  setTimeout(
                                    setFilteredDataDiagnostico([]),
                                    400
                                  );
                                }}
                                className="border-b py-2 px-5"
                              >
                                {`${item.name}`}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>

                      {/* Tratamiento */}
                      <div>
                        <InputOdontograma
                          label="Tratamiento"
                          color={true}
                          register={register("tratamiento", {
                            onChange: (e) => handleChange(e),
                            onBlur: () => setFilteredDataTratamiento([]),
                            onMouseDown: (e) => handleChange(e),
                          })}
                          type={"text"}
                        />
                        {filteredData?.length > 0 && (
                          <ul className="max-h-40 w-full border absolute rounded-lg z-50 bg-white overflow-y-scroll">
                            {filteredData?.map((item) => (
                              <li
                                key={item.id}
                                onMouseDown={() => {
                                  setValue("tratamiento", item.name);
                                  setTimeout(
                                    setFilteredDataTratamiento([]),
                                    400
                                  );
                                }}
                                className="border-b py-2 px-5"
                              >
                                {`${item.name}`}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>

                      {/* Costo */}
                      <InputOdontograma
                        label="Costo"
                        color={true}
                        register={register("costo", {
                          onChange: (e) => handleChangeCosto(e),
                        })}
                        type={"text"}
                        error={errors.costo}
                      />

                      {/* Botón Agregar */}
                      <div className="mt-8">
                        <Button
                          onClick={handleAgregarOdontograma}
                          Icon={BiPlus}
                          label="Agregar"
                        />
                      </div>
                    </div>

                    <div>
                      <div className="flex flex-col md:flex-row justify-between items-center mt-2">
                        {/* Título */}
                        <p className="text-black text-lg mb-4 md:mb-0">
                          Resumen Odontograma
                        </p>

                        {/* Botones */}
                        <div className="flex flex-row md:flex-row gap-2">
                          <div>
                            <button
                              onClick={() => handleCreateOdontograma()}
                              className="flex justify-center items-center bg-subMain rounded-lg text-white text-center text-2xl p-2"
                            >
                              <span className="text-sm mr-1">Guardar</span>
                              <FaSave />
                            </button>
                          </div>

                          <button
                            onClick={() => setIsOpenModalChart(true)}
                            className="flex justify-center items-center bg-subMain rounded-lg text-white text-center text-2xl p-2"
                          >
                            <span className="text-sm mr-1">
                              Imprimir Proforma
                            </span>
                            <FaFileDownload />
                          </button>
                        </div>
                      </div>

                      <div className="w-full overflow-x-scroll">
                        <OdontogramaTable
                          data={diagnosticoOdontograma}
                          updateRecord={updateRecord}
                          getOdontogramas={odontogramasData}
                          functions={{
                            delete: deleteRecordByIndex,
                            total: handleChangeTotal,
                            descuento: setDescuento,
                          }}
                          button={true}
                          descuento={
                            cita?.cita ? cita?.descuento : visita?.descuento
                          }
                          // excludes_childs={excludes_childs}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="absolute">
                  Este paciente todavía no tiene ninguna atención registrada —
                  el odontograma se habilita una vez creada la primera.
                </div>
              )}
            </div>
          </div>
          )}
        </TabPanel>
        <TabPanel>
          {/* Historial de tratamientos por pieza */}
          <HistorialTratamientos patientId={cita?.patient_id} patient={cita?.patient} />
        </TabPanel>
      </Tabs>
      )}
    </>
  );
}

export default NewMedicalRecode;
